import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-indicadores',
  templateUrl: './indicadores.component.html',
  styleUrls: ['./indicadores.component.css']
})
export class IndicadoresComponent implements OnInit {

  constructor(
    private router:Router
  ) { }

  ngOnInit(): void {
  }

  IrIndicadoresChv(){
    this.router.navigate(['indicadoreschv']);
  }

  IrIndicadoresFivi(){
    this.router.navigate(['indicadoresfivi-mensual']);
  }

  IrIndicadoresFiviTrimestral(){
    this.router.navigate(['indicadoresfivi-trimestral']);
  }

}
